import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadBlob } from "@/lib/api";

const base = "inline-flex items-center gap-2 rounded-full text-sm px-4 py-2 transition-opacity disabled:opacity-50 disabled:pointer-events-none";

// Link-style download for instant files; set `slow` to fetch with a spinner (e.g. video builds)
export const DownloadButton = ({ href, filename, label, icon: Icon = Download, slow, primary, disabled, testid, busyLabel = "Preparing…" }) => {
  const [busy, setBusy] = useState(false);
  const cls = `${base} ${primary ? "bg-[#22C55E] text-[#0F1117] font-semibold hover:opacity-90" : "border border-white/15 bg-white/5 hover:bg-white/10"}`;
  if (!slow)
    return (
      <a data-testid={testid} href={href} download={filename} className={`${cls} ${disabled ? "pointer-events-none opacity-50" : ""}`}>
        <Icon className="h-4 w-4" /> {label}
      </a>
    );
  const go = async () => {
    setBusy(true);
    try { await downloadBlob(href, filename); toast.success(`${filename} downloaded`); }
    catch { toast.error("Download failed, please try again"); }
    setBusy(false);
  };
  return (
    <button data-testid={testid} onClick={go} disabled={disabled || busy} className={cls}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Icon className="h-4 w-4" />} {busy ? busyLabel : label}
    </button>
  );
};

export const IconDownload = ({ href, testid, title }) => (
  <a data-testid={testid} href={href} download title={title}
    className="h-8 w-8 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80 transition-colors">
    <Download className="h-4 w-4" />
  </a>
);
